import { db, } from "../services/firebaseConfig";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";

export const getDistrictCode = (districtName) => {
    if (!districtName) return "XXX";

    const words = districtName.trim().toUpperCase().split(" ");

    if (words.length === 1) {
        return words[0].substring(0, 3);
    }

    if (words.length >= 2) {
        return words[0].substring(0, 2) + words[1].substring(0, 1);
    }

    return "XXX";
};

// 🔢 Penjana nombor tempahan / compiled order
export const generateRefNumber = async (type = "OR", district = "Unknown") => {
    const counterRef = doc(db, "inventori", "selangor", "settings", "orderCounter");
    const counterSnap = await getDoc(counterRef);

    let counters = {};
    let current = 1;

    if (counterSnap.exists()) {
        counters = counterSnap.data().counters || {};
        current = (counters[type] || 0) + 1;
        counters[type] = current;
        await updateDoc(counterRef, { counters });
    } else {
        counters[type] = 1;
        await setDoc(counterRef, { counters });
    }

    const code = getDistrictCode(district);
    const today = new Date();
    const dateStr = `${today.getDate().toString().padStart(2, "0")}${(today.getMonth() + 1)
        .toString()
        .padStart(2, "0")}${today.getFullYear().toString().slice(2)}`;

    const formattedCounter = current.toString().padStart(4, "0");

    return `${type}-${code}-${dateStr}-${formattedCounter}`;
};